import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  rentalsList: [],
  rental: {},
  isLoading: false,
  fetching: false,
  message: "",
  status: "",
};
const rentalsSlice = createSlice({
  name: "rentals",
  initialState,
  reducers: {
    fetchRentalPending: (state) => {
      state.isLoading = true;
    },
    fetchRentalSuccess: (state, { payload }) => {
      state.rental = payload.rentals;
      state.status = payload.desc;
      state.isLoading = false;
    },
    fetchRentalFail: (state, { payload }) => {
      state.message = payload.desc;
      state.status = payload.msg;
      state.isLoading = false;
    },
    fetchAllRentalsPending: (state) => {
      state.isLoading = true;
    },
    fetchAllRentalsSuccess: (state, { payload }) => {
      state.rentalsList = payload.rentals;
      state.status = payload.msg;
      state.isLoading = false;
    },
    fetchAllRentalsFail: (state, { payload }) => {
      state.message = payload.msg;
      state.status = payload.desc;
      state.isLoading = false;
    },
  },
});

const { reducer, actions } = rentalsSlice;

export const {
  fetchRentalPending,
  fetchRentalSuccess,
  fetchRentalFail,
  fetchAllRentalsPending,
  fetchAllRentalsSuccess,
  fetchAllRentalsFail,
} = actions;
export default reducer;
